// A company member's team role, as the app shows it: the role the server recorded in their
// marketplace metadata. The role on their own profile is theirs to edit, so it is never consulted.
// Answers the stored value as it is - undefined when nothing is recorded, null when the role was
// taken away. The server enforces every role rule on its own; this only decides what the app shows.

/**
 * @param {Object|null} user a current user or user entity
 * @returns {string|null|undefined}
 */
export const teamRoleOf = user => user?.attributes?.profile?.metadata?.teamRole;
